@if (isSectionVisible) {
<div class="container-fluid">
    <fieldset class="border rounded-3 p-1" [class.section-disabled]="isSectionLocked">
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.TITLE' | translate}}
            @if (optionalWorkflowCondition) {
            <si-check-box [isReadMode]="false" [isDisabled]="isDisabled || isReadOnlyMode"
                [isChecked]="isBidDocumentationChecked" (change)="onBidDocumentationToggle($event)"></si-check-box>
            }
        </legend>
<div class="row" [formGroup]="costReviewBidDocumentationFormGroup" trackChanges [appOptionalWorkflow]="optionalWorkflowCondition" [initialExpanded]="true">
    <div class="col-sm-6">
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="jobSpecifications">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.JOB_SPECIFICATIONS' | translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                <mat-radio-group class="radio-group" formControlName="jobSpecifications">
                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        @if (business !== constants.BUSINESS_SECURITY) {
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="mechanicalDrawings">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.MECHANICAL_DRAWINGS' | translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                <mat-radio-group class="radio-group" formControlName="mechanicalDrawings">
                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        }
        @if (business === constants.BUSINESS_FIRE) {
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="fireSystemElectricalDrawings">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.FIRE_SYSTEM_ELECTRICAL_DRAWINGS' | translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                <mat-radio-group class="radio-group" formControlName="fireSystemElectricalDrawings">
                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        }
        @if (business === constants.BUSINESS_SECURITY) {
          <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="securitySystemElectricalDrawings">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.SECURITY_SYSTEM_ELECTRICAL_DRAWINGS' | translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                <mat-radio-group class="radio-group" formControlName="securitySystemElectricalDrawings">
                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        }
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="exceptionsClarifications">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.EXCEPTIONS_CLARIFICATIONS' | translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                <mat-radio-group class="radio-group" formControlName="exceptionsClarifications">
                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="scopeOfWorkLetter">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.SCOPE_OF_WORK_LETTER' | translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                <mat-radio-group class="radio-group" formControlName="scopeOfWorkLetter">
                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="projectContractAddenda">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.PROJECT_CONTRACT_ADDENDA' | translate}}</mat-label>
            </div>
            <div class="col-sm-6 break-word">
                <app-si-form-field formControlName="projectContractAddenda" [maxlength]="40"
                [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                ></app-si-form-field>
            </div>
        </div>
      
    </div>
    <div class="col-sm-6">
        @if (business === constants.BUSINESS_FIRE) {
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="smokeControlSequence">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.SMOKE_CONTROL_SEQUENCE' | translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                <mat-radio-group class="radio-group" formControlName="smokeControlSequence">
                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        }
        @if (business !== constants.BUSINESS_SECURITY && (business === constants.BUSINESS_FIRE || isSalePriceGreaterThan150)) {
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="productPromotionReceived">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.PRODUCT_PROMOTION_RECEIVED' | translate}}</mat-label>
            </div>
            <div class="col-sm-6 mt-3">
                <span class="addPadding">
                    {{costReviewBidDocumentationAvailable?.producPromotionReceived}}
                </span>
            </div>
        </div>
        }
        @if (business === constants.BUSINESS_SECURITY) {
          <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="productDiscount">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.PRODUCT_DISCOUNT_APPLIED' | translate}}</mat-label>
            </div>
            <div class="col-sm-6">
                <mat-radio-group class="radio-group" formControlName="productDiscount">
                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </si-radio-button>
                </mat-radio-group>
            </div>
        </div>
        }
        @if (business === constants.BUSINESS_SECURITY || business === constants.BUSINESS_FIRE || isSalePriceGreaterThan150) {
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="subsidyReceived">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.SUBSIDY_RECEIVED' | translate}}</mat-label>
            </div>
            <div class="col-sm-6 mt-3">
                @if (costReviewBidDocumentationAvailable; as bidDocumentation) {
                    <span class="addPadding">{{bidDocumentation.subsidyReceived | multilingualCurrency}}</span>
                }
            </div>
        </div>
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="notes">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.NOTES_OTHER' | translate}}</mat-label>
            </div>
            <div class="col-sm-6 break-word mt-3 mb-3">
                <si-text-area [isReadMode]="isReadOnlyMode" 
                formControlName="notes" [isDisabled]="isDisabled"></si-text-area>
            </div>
        </div>
        }
        @if (business === constants.BUSINESS_SECURITY) {
        <div class="row bottomPadding">
            <div class="col-sm-6">
                <mat-label for="listAllAddenda">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.LIST_ALL_ADDENDA' | translate}}</mat-label>
            </div>
            <div class="col-sm-6 mt-3 mb-3">
                <si-text-area [isReadMode]="isReadOnlyMode"
                formControlName="listAllAddenda" [isDisabled]="isDisabled"></si-text-area>
            </div>
        </div>
        }
    </div>
    </div>
    </fieldset>
    @if (proposalLink && showProposalOpportunityLink) {
    <fieldset class="border rounded-3 p-1">
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'COMMON_LABELS.PROPOSAL' | translate}}</legend>
        <div class="row bottomPadding">
           
            <a [href]="proposalLink" target="_blank">
                {{proposalLink}}
            </a>
        </div>
    </fieldset>
    }
    @if (opportunityLink && showProposalOpportunityLink) {
    <fieldset class="border rounded-3 p-1">
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.OPPORTUNITY_DOCUMENTARY_REPOSITORY' | translate}}</legend>
        <div class="row bottomPadding">
          
            <a [href]="opportunityLink" target="_blank">
                {{opportunityLink}}
            </a>
        </div>
    </fieldset>
    }
</div>
}
@if (isSectionNotApplicableShow()) {
<div class="container-fluid">
    <fieldset class="border rounded-3 p-1" >
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_BID_DOCUMENTATION_TAB.TITLE' | translate}}</legend>
        <div class="row bottomPadding">
            <div class="col-sm-12">
                <span> {{'REVIEW_SOL_BID_DOCUMENTATION_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
            </div>
        </div>
    </fieldset>
</div>
}
@if (showSectionNotApplicableMsg && !costReviewBidDocumentationAvailable) {
<div class="container-fluid customizeText">
    {{'REVIEW_SOL_BID_DOCUMENTATION_TAB.BID_DOCUMENTATION_DATA_NOT_FOUND' | translate}}
</div>
}

